module.exports = __webpack_public_path__ + "media/svg/aq-d4203dfe.svg";